import * as Api from "../api/agent.js";

export const getAgentDashboardBalances = async (token, id, callback) => {
	try {
		const { data } = await Api.getAgentDashboardBalances(token, id);
		callback(data);
	} catch (error) {
		console.log("getAgentDashboardBalances error", error);
	}
};

export const getAgentsMaintenance = async (token, callback) => {
	try {
		const { data } = await Api.getAgentsMaintenance(token);
		callback(data);
	} catch (error) {
		console.log("getAgentsMaintenance error", error);
	}
};

export const agentLogin = async (username, password, ipAddress, callback) => {
	try {
		const { data } = await Api.agentLogin(username, password, ipAddress);
		callback(data);
	} catch (error) {
		console.log("agentLogin error", error);
	}
};

export const updateInsertAgent = async (token, agent, edit, callback) => {
	try {
		const { data } = await Api.updateInsertAgent(token, agent, edit);
		callback(data);
	} catch (error) {
		console.log("updateInsertAgent error", error);
	}
};

export const verifyTwoFactCode = async (token, pin, callback) => {
	try {
		const { data } = await Api.verifyTwoFactCode(token, pin);
		callback(data);
	} catch (error) {
		console.log("verifyTwoFactCode error", error);
	}
};

export const agentChangePassword = async (token, password, newpassword, callback) => {
	try {
		const { data } = await Api.agentChangePassword(token, password, newpassword);
		callback(data);
	} catch (error) {
		console.log("agentChangePassword error", error);
	}
};

export const getAgentTwoFactorInfo = async (token, callback) => {
	try {
		const { data } = await Api.getAgentTwoFactorInfo(token);
		callback(data);
	} catch (error) {
		console.log("agentChangePassword error", error);
	}
};

export const getAgentType = async (token, callback) => {
	try {
		const { data } = await Api.getAgentType(token);
		callback(data);
	} catch (error) {
		console.log("getAgentType error", error);
	}
};

export const getAgentTwoFactorActive = async (token, active, callback) => {
	try {
		const { data } = await Api.getAgentTwoFactorActive(token, active);
		callback(data);
	} catch (error) {
		console.log("agentChangePassword error", error);
	}
};

export const getAgentCustomers = async (token, callback) => {
	try {
		const { data } = await Api.getAgentCustomers(token);
		callback(data);
	} catch (error) {
		console.log("agentChangePassword error", error);
	}
};

export const getAgentCryptoCurrencies = async (token, callback) => {
	try {
		const { data } = await Api.getAgentCryptoCurrencies(token);
		callback(data);
	} catch (error) {
		console.log("agentChangePassword error", error);
	}
};

export const getAgentsByAgentMerchant = async (token, callback) => {
	try {
		const { data } = await Api.getAgentsByAgentMerchant(token);
		callback(data);
	} catch (error) {
		console.log("getAgentsByAgentMerchant error", error);
	}
};

export const updateAgentCryptoCurrency = async (token, cryptoCurrency, network, activeDepositform, activeWithdrawalform, freeplayform, freeplayamountform, callback) => {
	try {
		const { data } = await Api.updateAgentCryptoCurrency(token, cryptoCurrency, network, activeDepositform, activeWithdrawalform, freeplayform, freeplayamountform);
		callback(data);
	} catch (error) {
		console.log("updateAgentCryptoCurrency error", error);
	}
};
